export default [
  {
    title: 'Suites & Lots',
    route: 'products-suites-index',
    icon: 'dashboard.svg',
    customIcon: true,
    resource: 'Suite',
    action: 'read',
    parent: 'products',
  },
  {
    title: 'Locations',
    route: 'products-locations-index',
    icon: 'MapPinIcon',
    resource: 'SuiteLocation',
    action: 'read',
    parent: 'products',
  },
  {
    title: 'Areas',
    route: 'products-areas-index',
    icon: 'MapIcon',
    resource: 'SuiteArea',
    action: 'read',
    parent: 'products',
  },
]
